import React, { useMemo } from "react";
import { FilterGroup } from "../FilterBar";
import SegmentedControl from "../SegmentedControl";

export default function PositionFilter({ options, selected, onToggle }) {
  const segments = useMemo(
    () => options.map((pos) => ({ value: pos, label: pos })),
    [options]
  );

  return (
    <FilterGroup label="Position">
      <SegmentedControl
        options={segments}
        isSelected={(pos) => selected.includes(pos)}
        onSelect={onToggle}
      />
    </FilterGroup>
  );
}
